import "./GoToTariffOverviewTile.scss";

import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ArrowRight } from "@/assets/icons/icons";
import { DeviceTile } from "@/components/Portal/Cockpit/Tiles/DeviceTile/DeviceTile";

export const GoToTariffOverviewTile: FC = () => {
  const { t } = useTranslation(["partnerPortal"], {
    keyPrefix: "cockpit",
  });

  return (
    <a href={t("tariffOverview")} target="_blank" rel="noopener noreferrer">
      <DeviceTile dataTestid="tariff-overview-tile">
        <div className="tariff-overview-wrapper">
          <p className="tariff-overview-claim">{t("mobileInternet")}</p>
          <h2 className="mt-6 text-primary-100">{t("description")}</h2>
        </div>
        <div className="button-wrapper mt-auto">
          <button className="button">
            {t("callToAction")}
            <ArrowRight />
          </button>
        </div>
      </DeviceTile>
    </a>
  );
};
